<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=550 content-class="round-2xl" persistent)
  v-card
    v-card-title.pa-0
      div(style="width: 100%")
        v-row.pa-4(no-gutters align="center")
          v-col(cols="10" offset="1")
            div.text-xl.font-bold.neutral700--text.text-center {{ $t('download_item', { item: itemName }) }}
          v-col(cols="1" align="right")
            v-btn.ml-n3(text icon @click="closeDialog")
              v-icon(color="neutral700" :size="24") mdi-close
        v-divider
    div.px-6
      .text-md.mt-4.font-semibold {{ $t('download_item_description', { item: itemName }) }}
      .text-sm.mt-4.font-semibold.neutral500--text {{ $t('item_templates', { item: $options.filters.capitalize(itemName) }) }}
      v-radio-group.my-2(v-model="selectedDocument" mandatory hide-details)
        template(v-for="document in documents")
          v-radio.mb-4(:value="document" color="neutral700")
            template(v-slot:label)
              .neutral700--text.ml-2
                .text-md.font-medium {{ document.name }}
                .text-sm.font-normal {{ document.description }}
    v-divider.mt-6
    v-card-actions.px-6.py-3
      v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(:loading="isLoading" depressed dark @click="onConfirm") {{ $t('confirm') }}
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
    },
    documentType: {
      type: String,
      default: 'invoice',
      validator(value) {
        return ['invoice', 'receipt'].includes(value)
      }
    },
    documents: {
      type: Array,
      required: true
    },
    transaction: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    isLoading: false,
    selectedDocument: null
  }),
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      company: 'getCompany',
      isHq: 'hq/getIsHq'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    leadPid() {
      return this.$route.params.pid || this.$store.getters['treatment/getLeadPid']
    },
    itemName () {
      return this.documentType === 'invoice' ? this.$t('invoice').toLowerCase() : this.$t('receipt').toLowerCase()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    closeDialog () {
      this.showDialog = false
      this.$emit('closed')
    },
    async onConfirm () {
      let key
      try {
        this.isLoading = true
        const { data } = await this.$axios.post(`users/${this.user.id}/request_otk`)
        key = data.key
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        this.isLoading = false
        return
      }
      let baseUrl = process.env.VUE_APP_BASE_URL
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        baseUrl = 'https://api-test.yezza.io'
      } else if (process.env.VUE_APP_ENV === 'prod') {
        baseUrl = 'https://export.yezza.io'
      }
      const endpoint = this.isHq ? `/hq/invoices/${this.leadPid}` : `/invoices/${this.leadPid}`
      let url = `${baseUrl}${endpoint}/preview_document?document_template=${this.selectedDocument.id}&key=${key}`
      if (this.transaction) {
        url = `${url}&transaction=${this.transaction.uid}`
      }
      window.open(url,'_blank')
      this.isLoading = false
    }
  }
}
</script>